/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoCtrCommonInfo {
    /**
     * 契約開始日付：日付(yyyyMMdd)
     */
    ctrstrDate?: string;
    /**
     * 契約開始予定時刻：英数字<br>　コード変換マスターテーブル.画面項目ID「C401081」のユーザコードを設定
     */
    ctrstrTimez?: string;
    /**
     * 契約開始予定時刻名称：全半角混在
     */
    ctrstrTimezAname?: string;
    /**
     * 契約終了日付：日付(yyyyMMdd)
     */
    ctrendDate?: string;
    /**
     * 契約終了予定時刻：英数字<br>　コード変換マスターテーブル.画面項目ID「C401081」のユーザコードを設定
     */
    ctrendTimez?: string;
    /**
     * 契約終了予定時刻名称：全半角混在
     */
    ctrendTimezAname?: string;
    /**
     * 契約変更日付：日付(yyyyMMdd)
     */
    ctrChgDate?: string;
    /**
     * 請求開始月：英数字<br>　コード変換マスターテーブル.画面項目ID「C401100」のユーザコードを設定<br>　※NULL返却
     */
    claimSrtmnt?: string;
    /**
     * 請求開始月名称：全半角混在<br>　※NULL返却
     */
    claimSrtmntAname?: string;
    /**
     * 請求月度区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021080」のユーザコードを設定
     */
    claimMntdiv?: string;
    /**
     * 請求月度区分名称：全半角混在
     */
    claimMntdivAname?: string;
    /**
     * 販売形態コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300020」のユーザコードを設定
     */
    salfrmCode?: string;
    /**
     * 販売形態コード名称：全半角混在
     */
    salfrmCodeAname?: string;
    /**
     * 中継店内部お客さま番号：数字
     */
    rlyisdVisitNo?: string;
    /**
     * 中継店申込番号：英数字
     */
    rlysrnNo?: string;
    /**
     * 中継店担当者名：全角
     */
    rlystrFname?: string;
    /**
     * 取次店発行お客さま番号：英数字
     */
    agnissVisitNo?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * プロダクトコード名称：全角
     */
    prdCodeAname?: string;
    /**
     * サービス契約締結日付：日付(yyyyMMdd)
     */
    prdCtrDate?: string;
    /**
     * サービス契約解約理由コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000860」のユーザコードを設定
     */
    srvbrkRsncod?: string;
    /**
     * サービス契約解約理由コード名称：全半角混在
     */
    srvbrkRsncodAname?: string;
    /**
     * 契約管轄組織番号：英数字
     */
    ctrSosikiId?: string;
    /**
     * 契約締結組織番号：英数字
     */
    tantoSosikiId?: string;
    /**
     * 契約締結社員番号：英数字
     */
    tantoStaffNo?: string;
    /**
     * 契約解約組織番号：英数字
     */
    breakSosikiId?: string;
    /**
     * 契約解約社員番号：英数字
     */
    breakStaffNo?: string;
    /**
     * 免税対象フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C000350」のユーザコードを設定
     */
    exmptTargetFlg?: string;
    /**
     * 免税対象フラグ名称：全半角混在
     */
    exmptTargetFlgAname?: string;
}

